interface LoadingSpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

export default function LoadingSpinner({ size = 'sm', className = 'absolute top-4 right-8' }: LoadingSpinnerProps) {
  const sizeClasses = {
    sm: 'h-3 w-3 border-2',
    md: 'h-5 w-5 border-2',
    lg: 'h-8 w-8 border-3'
  };

  return (
    <div className={className}>
      <div
        className={`animate-spin rounded-full border-gray-300 border-t-blue-500 ${sizeClasses[size]}`}
      />
    </div>
  );
}
